module.exports = __webpack_public_path__ + "static/media/usd-circle.c8565854.svg";